import {FILTER} from "./filter";
import {U, TOOLTIP} from "./global";
import {CABINET} from "./cabinet";
import {CARD} from "./card";
import {GTM} from "./gtm";

export const MAKEPC = {
    skus: [],
    errors: [],
    sum: 0,
    assembly: 0,
    position: 0,
    _set_id: 0,
    was_page: '',
    was_errors: [],
    errors_relations: [],
    url: '/computer_parts/makepc/',
    qty: `<a href="#" class="mpc__qtyitem js-mpc__qtyitem" data-qty="1">1 шт.</a>
<a href="#" class="mpc__qtyitem js-mpc__qtyitem" data-qty="2">2 шт.</a>
<a href="#" class="mpc__qtyitem js-mpc__qtyitem" data-qty="3">3 шт.</a>
<a href="#" class="mpc__qtyitem js-mpc__qtyitem" data-qty="4">4 шт.</a>
<a href="#" class="mpc__qtyitem js-mpc__qtyitem" data-qty="5">5 шт.</a>`,

    service_code: function() {
        return $(".js-mpc__servicecode").val();
    },

    menu: function(sku, flat_id) {
        return `<a href="#" class="mpc__menuitem mpc__menuitem-replace js-mpc__productchangedesktop" data-sku="${sku}" data-id="${flat_id}">Замінити</a>
        <a href="#" class="mpc__menuitem mpc__menuitem-remove js-mpc__productremovedesktop" data-sku="${sku}">Видалити</a>`;
    },

    write2lead: function()
    {
        return this.postData({
            skus: this.skus,
            errors: this.errors,
            sum: this.sum,
            assembly: this.assembly
        }, 'write2lead');
    },

    postData: async function (data = {}, url = 'config') {
        data.sku = this.skus;

        const response = await fetch(`${this.url}${url}`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },

    remove: function(id) {
        return this.postData({
            id: id
        }, 'remove');
    },

    updateUrl: function(isHistoryBack = false) {
        let url = `${this.url}${this.skus.join(',')}${this._set_id > 0 ? `?set_id=${this._set_id}` : ''}`;

        if (this.was_page!=url) {
            this.was_page = url;
        }

        if (!isHistoryBack) {
            history.pushState({}, null, url);
        }
    },

    clean: function() {
        this.skus = [];
        this.products = [];
        this.init();
    },

    save: function(title) {
        return this.postData({
            title: title,
            mobile: U.isMobile() ? 1 : 0,
            id: this._set_id
        }, 'save').then((data) => {
            this._set_id = data.id;
        });
    },

    addSku: function(sku) {
        let added = false;

        this.skus = this.skus.map((_sku) => {
            _sku = _sku.toString().split('.');
            let __sku = _sku[0];
            let qty = parseInt(_sku[1] ?? 1);

            if (__sku==sku) {
                qty++;
                added = true;
            }

            return qty > 1 ? `${__sku}.${qty}` : __sku;
        });

        if (!added) {
            this.skus.push(sku);
        }

        this.fix_body(false);
        this.init();
    },

    removeSku: function(sku) {
        this.skus = this.skus.filter(_sku => {
            _sku = _sku.toString().split('.');
            let __sku = _sku[0];
            let qty = parseInt(_sku[1] ?? 1);

            return __sku!=sku;
        });

        this.init();
    },

    replaceSku: function(old_sku, new_sku)
    {
        this.skus = this.skus.filter(_sku => {
            _sku = _sku.toString().split('.');
            let __sku = _sku[0];
            let qty = parseInt(_sku[1] ?? 1);

            return __sku!=old_sku;
        });

        this.addSku(new_sku);
    },

    update: function(data, url) {
        return this.postData(data, url);
    },

    set_id: function(set_id) {
        this._set_id = set_id;
    },

    init: function(skus = '', isHistoryBack = false) {
        if (arguments.length > 0) {
            this.skus = skus.split(',');
        }

        // scroll to right position
        if (this.position > 0) {
            // was opened filter
            $(".mpc__filterwindow").remove();
            $("html, body").stop().animate({scrollTop: this.position}, '200', 'swing');
            this.position = 0;
        } else{
            // loading window
            $(".js-mpc").addClass('mpc-loading');
        }

        // update data & build new container
        this.update().then(data => {
            this.build(data, isHistoryBack);
        });
    },

    showErrors: function(errors = []) {
        let unique = [...new Set(errors)];
        unique.map(error => {
            let el = $(`<div class="mpc__terror"><span>Несумісна конфігурація</span>${error}</div>`);
            el.appendTo('.mpc__terrors');

            el.on('click', function() {
                $(this).remove();
            })

            setTimeout(() => {
                el.fadeOut('fast', function() {
                    $(this).remove()
                });
            }, 5000)
        });
    },

    build: function(data, isHistoryBack = false) {
        let container = $(".js-mpc");
        container.empty();
        this.skus = data.skus;
        this.products = data.products;
        this.errors = data.errors;
        this.sum = data.total.sum;
        this.assembly = data.assembly;
        this.updateUrl(isHistoryBack);

        data.items.map((item) => {
            container.append(MAKEPC_H1(item));
        });

        this.errors_relations = data.errors_relations;
        let errors_qty = data.errors.length;
        let total = data.energyconsumption.parts.reduce((sum, current) => { return sum + current.consumption}, 0);
        $(".mpc__twenergyi").removeClass('js-makepc__black-tooltip mpc__twenergyi-red mpc__twenergyi-orange');

        if (data.energyconsumption.powersupply > 0) {
            let percent = total/data.energyconsumption.powersupply;

            if (percent >= 0.9) {
                $(".js-mpc__twenergyi-powersupply").addClass('js-makepc__black-tooltip');
                if (percent >= 1) {
                    $(".js-mpc__twenergyi-powersupply").addClass('mpc__twenergyi-red');
                    $(".mpc__twenergyi").data('text', 'Потужності блоку живлення недостатньо');
                } else {
                    $(".js-mpc__twenergyi-powersupply").addClass('mpc__twenergyi-orange');
                    $(".mpc__twenergyi").data('text', 'Потужності блоку живлення недостатньо');
                }
            }
        }

        // new errors
        let __errors = data.errors.map(x => x.error);
        let difference = __errors.filter(x => !this.was_errors.includes(x));

        if (difference.length)
            this.showErrors(difference);

        this.was_errors = __errors;

        // total
        if (data.total.price[980] || data.total.price[840]) {
            let price_html = [];

            if (data.total.price[980])
                price_html.push(`${data.total.price[980]} грн`);

            if (data.total.price[840])
                price_html.push(`${data.total.price[840]} у.о.`);

            $(".js-mpc__totalprice").removeClass('hidden').html(price_html.join(', '));
            $(".js-mpc__totalqty").html(data.total.qty);
            $(".mpc__total").removeClass('hidden');
        }

        console.log('errors_qty', errors_qty);
        if (errors_qty > 0) {
            $(".mpc__totalbtnm").addClass('mpc__totalbtnm-error');

            let suffix = ``;

            if (errors_qty==1) {
                suffix = 'помилка';
            } else if (errors_qty==2 || errors_qty==3 || errors_qty==4) {
                suffix = 'помилки';
            } else {
                suffix = 'помилок';
            }

            $(".js-mpc__totaldetails").addClass('mpc__totaldetails-error').html(`${errors_qty} ${suffix}`);
            $(".js-mpc__twerrors").empty().html(`<hr /><div class="mpc__twerrorslist">${data.errors.map((item) => {
                return `<div class="mpc__twerror" data-context="${item.context_id}"><span>${item.type??'Помилка збірки'}</span>${item.error}</div>`;
            }).join('')}</div>`).removeClass('hidden');
            $(".js-mpc__totalinner-errors").removeClass('hidden').html(`${errors_qty} ${suffix}`);
        } else {
            $(".mpc__totalbtnm").removeClass('mpc__totalbtnm-error');
            $(".js-mpc__totaldetails").removeClass('mpc__totaldetails-error').html('Детально');
            $(".js-mpc__twerrors").addClass('hidden');
            $(".js-mpc__totalinner-errors").addClass('hidden');
        }

        // credit
        if (data.credit!='') {
            $(".mpc__credit").removeClass('hidden').html(data.credit);
        } else {
            $(".mpc__credit").addClass('hidden');
        }

        // requires
        $(".js-mpc__qtyi").html(`<div class="c100 p${parseInt((data.required.filled / data.required.total ) * 100)}"><div class="slice"><div class="bar"></div><div class="fill"></div></div></div>${data.required.filled}/${data.required.total} обовязкових товарів`);

        // icons
        $(".js-mpc__twcomponents-main, .js-mpc__twcomponents-additional").empty();

        // fill additional
        let fill_main = [43, 85, 126, 161, 250, 298, 33, 118];

        let additional_components = [];
        let contexts = new Map();
        data.items.map((flat) => {
            flat.contexts.map((context) => {
                contexts.set(context.id, context);

                let selected_count = context.items.reduce((total_selected, _item) => total_selected + _item.selected.length, 0);

                if (fill_main.includes(context.id)) {
                    $(".js-mpc__twcomponents-main").append(`
                    <div class="mpc__twcomponent">
                        <div class="mpc__twicon js-mpc__twicon mpc__twicon-required ${selected_count > 0 ? `mpc__twicon-checked` : ``} ${context.error.length ? `mpc__twicon-error js-makepc__black-tooltip` : ``}" 
                            ${U.isMobile() && context.error.length ? `data-place="top"` : ``} 
                            data-title="Помилки сумісності" 
                            data-text="${context.error.join('')}"
                            data-context="${context.id}"
                        >
                            <div class="mpc__i mpc__i-${context.id} ${selected_count > 0 ? `` : `mpc__i-${context.id}-unchecked`}"></div>
                        </div>
                        <span>${context.title}</span>
                    </div>
                    `);
                } else {
                    if (selected_count) {
                        additional_components.push(context.id);
                        $(".js-mpc__twcomponents-additional").append(`
                            <div class="mpc__twcomponent">
                                <div class="mpc__twicon mpc__twicon-checked">
                                    <div class="mpc__i mpc__i-${context.id} mpc__i-${context.id}-checked"></div>
                                </div>
                                <span>${context.title}</span>
                            </div>
                        `);
                    }
                }
            });
        });

        // fill additional
        let fill_additional = [48, 94, 76, 10, 103];

        fill_additional.map(context_id => {
            if (!additional_components.includes(context_id)) {
                let context = contexts.get(context_id);
                $(".js-mpc__twcomponents-additional").append(`
                    <div class="mpc__twcomponent">
                        <div class="mpc__twicon">
                            <div class="mpc__i mpc__i-${context.id} mpc__i-${context.id}-unchecked"></div>
                        </div>
                        <span>${context.title}</span>
                    </div>
                `);
            }
        });

        $(".js-mpc__twcomponents-additional").append(`
                <div class="mpc__twcomponent js-mpc__twcomponent-more cursor-pointer">
                    <div class="mpc__twicon">
                        <div class="mpc__i mpc__i-more"></div>
                    </div>
                    <span><strong>Показати всі</strong></span>
                </div>
            `);

        if ($(".mpc__twcomponentsd .mpc__twcomponent").length > 0) {
            let cc = 1;
            $(".mpc__twcomponentsd .mpc__twcomponent:not(.js-mpc__twcomponent-more)").map((i, item) => {
                if (cc > 14)
                    $(item).remove();
                cc++
            });
        }

        if ($(".js-mpc__twcomponents-additional >div").length > 0) {
            $(".js-mpc__twcomponents-outer").removeClass('hidden');
        } else {
            $(".js-mpc__twcomponents-outer").addClass('hidden');
        }

        $(".js-mpc__twenergyi-parts").html(`${total} Вт`);
        $(".js-mpc__twenergyi-powersupply").html(`${data.energyconsumption.powersupply} Вт`);

        $(".js-mpc__totaldetails").removeClass('hidden');

        // remove loading screen
        container.removeClass('mpc-loading');
    },

    append_filter_window: function(container) {

        let el = $('<div class="mpc__filterwindow mpc__filterwindow-loading"></div>');
        if (!U.isMobile()) {
            el.css({
                'top': container.outerHeight(),
                'height': U.viewportH() - container.outerHeight() - $(".mpc__total").outerHeight()
            });
        }
        container.append(el);
        return el;
    },

    open_available_services: function() {
        const container = $(".js-mpc__context[data-id=326]");
        const selected_sku = container.find('.js-mpc__product').length > 0 ? container.find('.js-mpc__product').data('sku') : 0;

        this.postData({
            selected_sku
        }, 'services').then(
            (data) => {
                $(".mpc__servicegoods").remove();
                container.append(data.html);
            });
    },

    open_filter: function(btn, selected_sku = 0) {

        this.position = $(document).scrollTop();

        let container = btn.parents('.mpc__context');
        let flat_id = btn.data('id');

        if (container.hasClass('mpc__context-opened')) {
            if (U.isMobile()) {
                FILTER.hidemobile();
            }

            this.fix_body(false);
            container.removeClass('mpc__context-opened').parents('.mpc__contexts').removeClass('mpc__contexts-opened');
            container.find('.js-mpc__product').removeClass('hidden');
            $(".mpc__filterwindow").remove();
            $("html, body").stop().animate({scrollTop: container.offset().top - 150}, '50', 'swing');
        } else {

            container.find('.js-mpc__product').addClass('hidden');

            if (selected_sku)
                container.find('.js-mpc__product[data-sku=' + selected_sku + ']').removeClass('hidden');

            container.addClass('mpc__context-opened').parents('.mpc__contexts').addClass('mpc__contexts-opened');
            this.fix_body(true);
            let filterwindow = this.append_filter_window(container);

            if (U.isMobile()) {
                $("html, body").stop().animate({scrollTop: container.offset().top - 50}, '20');
            } else {
                $("html, body").stop().animate({scrollTop: container.offset().top}, '50', 'swing');
            }

            this.update({
                id: flat_id
            }, 'getfilter').then(result => {

                FILTER.setExtendParams({
                    // filter params
                    accs_conditions: JSON.stringify(result.accs_conditions),
                    selected_sku: selected_sku,
                    lookup: 'related'
                });

                FILTER.extend_options({
                    filter: {
                        url: '/pcfilter/',
                        is_catalog: 1,
                        catalog_id: result.context_id,
                        currentpage: 1,
                        originpage: 1,
                        action: 'pcfilter',
                        change_url: false,
                        previewmode: this.previewmode(),
                        _is_mpc: true,
                        force_update: 1,
                        title_replace: false,
                        more_opened: false,
                        filter_replace: true,
                        catalog_default_sort_field: 'top',
                        catalog_default_sort_direction: 'asc',
                    }
                });

                this.postData({
                    previewmode: this.previewmode()
                }, 'accstab').then(
                (data) => {
                    filterwindow.html(data.html);
                    FILTER.load(1).then(() => {
                        filterwindow.removeClass('mpc__filterwindow-loading');
                        if (U.isMobile()) {
                            $(".catalog__header").detach().appendTo($(".mpc__contexts-opened .mpc__contextt"));
                        }

                        $(".js-looplist .js-makepc__relatederrors").remove();

                        if ($(".js-looplist .loop, .js-looplist .loopw").length==0) {
                            // error holder
                            let related_errors = Object.values(this.errors_relations[result.context_id] || {});


                            if (related_errors.length > 0) {
                                $(".js-looplist").append(`<div class="mpc__relatederrors js-makepc__relatederrors"><span>Можливі проблеми: </span><br />${related_errors.join('<br />')}</div>`);
                            }
                        }
                    });

                    if (U.isMobile()) {
                        $(".mpc__total").removeClass('hidden');
                    }
                });
            });
        }
    },

    previewmode: function() {
        return U.isMobile() ? 'grid' : (localStorage.getItem('makepc_previewmode') ?? 'grid');
    },

    fix_body: function(lock = true) {
        if (lock)
            $("body, html").addClass('disablescroll');
        else
            $("body, html").removeClass('disablescroll');
    }
}

export function MAKEPC_H1(data) {
    let hidden = data.hidden ?? false;

    return `
        ${hidden ? `` : `<div class="mpc__h1"><span class="js-mpc__h1">${data.title}</span>${data.title=='Системний блок' ? `<div class="qtyi js-mpc__qtyi mobileVisible"></div>` : ``}</div>`}
        ${MAKEPC_CONTEXTS(data.contexts)}
    `;
}

export function MAKEPC_CONTEXTS(contexts) {
    let hidden_shown = false;
    let html = contexts.map((item) => {
        let items = ``;
        let required = false;

        items = item.items.map((_item) => {
            if (_item.required)
                required = true;

            return `<div class="mpc__contextfewone mpc__contextfewone-${_item.id} js-mpc__contextfew" data-id="${_item.id}" data-flat_id="${item.id}">${_item.title}</div>`;
        }).join('');

        let hidden_html = ``;
        if (item.hidden && !hidden_shown) {
            hidden_shown = true;
            hidden_html = `<div class="mpc__context mpc__contextshowall"><a href="#" class="js-mpc__contextshowall">Показати всі</a></div>`;
        }

        return `${hidden_html}<div class="mpc__context js-mpc__context ${item.hidden ? `hidden` : ``}" data-id="${item.id}" id="context${item.id}">
                <div class="mpc__contextt" data-id="${item.id}">
                    <div class="mpc__contexttt">
                        <div class="mpc__contexticon mpc__contexticon-${item.id} ${item.error.length > 0 ? `mpc__contexticon-${item.id}-error` : ``}"></div>
                            <span class="js-mpc__contexticon">${item.title}</span>
                        ${MAKEPC_ERRORBTN(item, required)}
                        ${MAKEPC_STOREBTN()}
                    </div>
                    ${MAKEPC_SELECTED_LIST(item)}
                    ${MAKEPC_ADD_BTN(item)}
                </div>
                ${items && item.items.length > 1 ? `<div class="mpc__contextfew hidden">${item.items.length > 0 ? items : ''}</div>` : ''}
            </div>`;

    }).join('');

    return `<div class="mpc__contexts">${html}</div>`;
}

function MAKEPC_STOREBTN() {
    return G.manager_logged ? `<a href="#" class="mpc__switchstore ${G.mystore ? `mpc__switchstore-active` : ''} js-mpc__switchstore"></a>` : ``;
}

export function MAKEPC_ADD_BTN(item) {
    let flat_id = item.items[0].id;

    return `<div class="mpc__contextbuttons">
        <a href="#" class="mpc__contextclose js-mpc__contextclose" data-id="${flat_id}"></a>
        <a href="#" class="mpc__contextadd js-mpc__contexttitletadd" data-id="${flat_id}">Додати</a>
    </div>`;
}

export function MAKEPC_SELECTED_LIST(context) {
    let list = context.items.reduce((arr, item) => {
        item.selected.map((_item) => {
             arr.push(MAKEPC_SELECTED(_item, item, context));
        });

        return arr;
    }, []);

    let max_goods = context.max_goods ?? context.items.reduce((total_selected, _item) => total_selected + _item.max_goods, 0);

    return `<div class="mpc__contextselected ${list.length > 0 ? 'mpc__contextselected-filled' : ''} js-mpc__contextt-selected">
        ${list.join('')}
        ${list.length > 0 && max_goods > 1 ? `<div><a href="#" class="mpc__contextadd mpc__contextadd-more js-mpc__contexttitletadd" data-id="${context.items[0].id}"><span>Додати ще</span></a></div>` : ''}
    </div>`;
}

export function MAKEPC_SELECTED(item, flat, context) {
    let max_goods = context.max_goods ?? context.items.reduce((total_selected, _item) => total_selected + _item.max_goods, 0);

    return `<div class="mpc__product js-mpc__product" data-sku="${item.sku}" data-id="${flat.id}">
        <a class="mpc__productimage" href="${item.url}" target="_blank">
            <img src="${item.image}" border="0" />
        </a>
        <div class="mpc__producttext">
            <a class="mpc__producttextt" href="${item.url}" target="_blank">${item.title}</a>
            ${item.price > 0 ? `<div class="mpc__productprice ${item.price_old ? 'mpc__productprice-red' : ''}">${item.price_format} ${item.currency} </div>` : `<div class="mpc__producthavent">Немає в наявності</div>`}
            <div class="mpc__productqty js-mpc__productqty ${max_goods > 1 ? '' : 'hidden'}">
                <span class="value">${item.qty??1} шт.</span>
            </div>
            
            ${item.credit}

        </div>
        <div class="mpc__productbuttons">
            <a href="#" class="mpc__productchange js-mpc__productchange" data-sku="${item.sku}" data-id="${flat.id}">Замінити</a>
            <a href="#" class="mpc__productremove js-mpc__productremove"></a>
            <a href="${item.url}" class="mpc__productlink hidden" target="_blank">Перейти до товару</a>
        </div>
    </div>`;
}

export function MAKEPC_ERRORBTN(item, required) {
    let text = '';

    if (item.error.length > 0) {
        return `<div class="mpc__error js-makepc__black-tooltip" data-placement="top" data-title="Несумісна конфігурація" data-text="${item.error.join(', ')}"></div>`;
    } else {
        if (item.selected && item.selected.length > 0) {
            text = 'Доданий до збірки';
        } else {
            if (required) {
                text = 'Обо\'язково';
            } else {
                text = 'Не обо\'язково';
            }
        }
    }

    return `<div class="open-tooltip open-tooltip-simple pc__i ${required ? 'pc__i-required': ''} ${item.selected ? 'pc__i-checked': ''} ${item.error ? 'pc__i-error': ''}" title="${text}"></div>`;
}

export function init_MAKEPC_events() {
    jQuery(document).ready(function () {

        jQuery("body").on('click', '.js-mpc__twcomponent-more ', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            $("html, body").stop().animate({scrollTop: $("#context48").offset().top - 150}, '200', 'swing');
        });

        jQuery("body").on('click', '.js-mpc__contextshowall', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let container = btn.parent().parent();
            btn.parent().remove();
            container.find('.mpc__context').removeClass('hidden');
        });

        jQuery("body").on('click', '.js-mpc__context', function (e) {
            let btn = $(this);

            if (!btn.parents('.mpc__contexts').hasClass('mpc__contexts-opened') && btn.find('.mpc__product').length==0) {
                e.preventDefault();
                e.stopPropagation();

                btn.find('.js-mpc__contexttitletadd').trigger('click');
            }
        });

        jQuery("body").on('click', '.js-makepc__buyreplace', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let old_sku = btn.parents('.mpc__context').find('.js-mpc__product').data('sku');

            GTM.event(
                'select_product',
                btn.parents('.mpc__contexts').prev().find('.js-mpc__h1').text(),
                btn.parents('.mpc__context').find('.js-mpc__contexticon').text(),
                btn.data('sku')
            );

            MAKEPC.replaceSku(old_sku, btn.data('sku'));
        });

        jQuery("body").on('click', '.js-mpc__productqty', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            TOOLTIP.open(btn, {
                target: 'html',
                html: MAKEPC.qty,
                place: 'bottom',
                toggle: 'mpc__productqty-opened',
                subclass: 'tooltip-mpcqty'
            });
        });

        jQuery("body").on('click', '.js-mpc__productmenu', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            TOOLTIP.open(btn, {
                target: 'html',
                html: MAKEPC.menu(btn.data('sku'), btn.data('id')),
                place: 'bottom',
                toggle: 'mpc__productmenu-opened',
                subclass: 'tooltip-mpcmenu'
            });
        });

        if (!U.isMobile()) {
            jQuery("body").on('click', '.mpc__context-opened .mpc__contexttt', function (e) {
                e.preventDefault();
                e.stopPropagation();
                let btn = $(this);
                MAKEPC.open_filter(btn, btn.data('sku'));
            });
        }

        // used ?
        jQuery("body").on('click', '.js-mpc__productchangedesktop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let th = $(this);
            let btn = $(`.mpc__producthover .js-mpc__productchange[data-sku=${th.data('sku')}][data-id=${th.data('id')}]`);
            TOOLTIP.hide();
            MAKEPC.open_filter(btn, btn.data('sku'));
        });

        jQuery("body").on('click', '.js-mpc__productchange, .js-mpc__contextclose', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            const is_service = btn.parents('.mpc__context').data('id')=='326';
            const opened = btn.hasClass('js-mpc__contextclose');
            $(".mpc__servicegoods").remove();

            GTM.event('select_product', btn.parents('.mpc__contexts').prev().find('.js-mpc__h1').text(), btn.parents('.mpc__contextt').find('.js-mpc__contexticon').text());

            if (is_service && !opened) {
                MAKEPC.open_available_services();
            } else {
                if ($(".catalog__header").length > 0) {
                    $(".catalog__header").remove();
                }
                MAKEPC.open_filter(btn, btn.data('sku'));
            }
        });

        jQuery("body").on('click', '.js-mpc__contexttitletadd', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let context = btn.parents('.mpc__context');
            const is_service = context.data('id')=='326';
            const opened = $(".mpc__servicegoods").length > 0;

            // js-mpc__productchange
            GTM.event('select_product', btn.parents('.mpc__contexts').prev().find('.js-mpc__h1').text(), btn.parents('.mpc__contextt').find('.js-mpc__contexticon').text());

            if (is_service) {
                if (opened) {
                    $(".mpc__servicegoods").remove();
                } else {
                    MAKEPC.open_available_services();
                }
            } else {
                if (context.find('.mpc__contextfew').length > 0) {
                    TOOLTIP.open(btn, {
                        target: 'html',
                        html: context.find('.mpc__contextfew').html(),
                        place: 'bottom',
                        subclass: 'tooltip-mpcaddfew'
                    });
                } else {
                    MAKEPC.open_filter(btn);
                }
            }

        });

        jQuery("body").on('click', '.js-mpc__productremovedesktop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            TOOLTIP.hide();
            MAKEPC.removeSku($(this).data('sku'));
        });

        jQuery("body").on('click', '.js-mpc__productremove', function (e) {
            e.preventDefault();
            e.stopPropagation();
            MAKEPC.removeSku($(this).parents('.mpc__product').data('sku'));
        });

        jQuery("body").on('click', '.js-makepc__buy', function (e) {
            e.preventDefault();
            let btn = $(this).parents('.loop, .loopw').find('.loop__title');
            $(".mpc__context-opened .js-mpc__contextt-selected").append(`<small>${btn .text()}</small>`);
            MAKEPC.addSku(btn.data('sku'));
        });

        jQuery("body").on('click', '.js-mpc__contextt-fewcontexts', function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.parent().hasClass('mpc__context-opened')) {
                MAKEPC.open_filter($(".mpc__context-opened .js-mpc__context"));
            }
            else {
                btn.parent().find('.mpc__contextfew').toggleClass('hidden');
            }
        });

        jQuery("body").on('click', '.js-mpc__contextfew', function (e) {
            e.preventDefault();
            TOOLTIP.hide();
            let btn = $(this);
            let container = $(".mpc__context[data-id=" + btn.data('flat_id') + "]");
            let created = $("<div></div>");

            created.data('id', btn.data('id')).appendTo(container);
            MAKEPC.open_filter(created);
        });

        jQuery("body").on('click', '.js-makepc__errorstitle', function (e) {
            e.preventDefault();
            $(".js-makepc__errors").toggleClass('hidden');
        });

        jQuery("body").on('click', '.js-makepc__energytitle', function (e) {
            e.preventDefault();
            $(".js-makepc__energy").toggleClass('hidden');
        });

        jQuery("body").on('click', '.js-mpc__qtyitem', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let container = $(".mpc__productqty-opened").parents('.mpc__product');

            MAKEPC.replaceSku(container.data('sku'), `${container.data('sku')}.${btn.data('qty')}`);
            TOOLTIP.hide();
        });

        jQuery("body").on('click', '.js-mpc__togglesearch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            btn.parent().find('.filter__tglbtn-active').removeClass('filter__tglbtn-active');
            btn.addClass('filter__tglbtn-active');

            FILTER.setExtendParams({
                lookup: btn.data('val')
            });

            FILTER.extend_options({
                filter: {
                    force_update: 1
                }
            });

            FILTER.load(true);
        });

        jQuery("body").on('click', '.js-mpc__totaldetails, .js-mpc__twclose', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(".mpc__tw").hasClass('hidden')) {
                $(".mpc__totalbtnm").addClass('mpc__totalbtnm-opened');
                $(".mpc__tw").toggleClass('hidden');
                $(".mpc__totaldetails").addClass('mpc__totaldetails-opened');

                if (!U.isMobile()) {
                    $(".menubg-contain").addClass('show');
                }
                U.bodyscroll(false);
            } else {
                $(".mpc__totalbtnm").removeClass('mpc__totalbtnm-opened');
                $(".mpc__tw").toggleClass('hidden');
                $(".mpc__totaldetails").removeClass('mpc__totaldetails-opened');
                U.close_all();
                U.bodyscroll(true);
            }

        });

        jQuery("body").on('click', '.js-mpc__clean', function (e) {
            e.preventDefault();
            e.stopPropagation();
            MAKEPC.clean();
        });

        jQuery("body").on('click', '.js-makepc__black-tooltip', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let data = btn.data();
            data.subclass = 'tooltip-black';
            data.target = 'black';
            data.place = data.place ?? 'top';
            let el = TOOLTIP.open(btn, data);

            /*
            el.on('tooltip:on', (e) => {
                $(`.mpc__twerrorslist .mpc__twerror`).not(`[data-context=${btn.data('context')}]`).addClass('hidden');
            });

            el.on('tooltip:off', (e) => {
                $(".mpc__twerrorslist .mpc__twerror").removeClass('hidden');
            });

            el.trigger('tooltip:on');
            */
        });

        jQuery("body").on('click', '.js-mpc__switchstore', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            CABINET.switch_store(btn.hasClass('mpc__switchstore-active') ? 1 : 0).then(() => {
                FILTER.extend_options({
                    filter: {
                        force_update: 1
                    }
                });

                FILTER.load(true);

                btn.toggleClass('mpc__switchstore-active');
            });
        });

        jQuery("body").on('click', '.js-mpc__twcloseadd', function (e) {
            e.preventDefault();
            e.stopPropagation();
            U.close_all();
        });

        jQuery("body").on('click', '.js-mpc__save', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (G.user_id > 0) {
                $(".menubg").addClass('show');
                $(".mpc__twshare").removeClass('hidden');
            } else {
                $(".header__login").trigger('click');
                // $(".js-mpc__share").trigger('click', '.js-mpc__save');
            }
        });

        jQuery("body").on('click', '.js-mpc__savemobile', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (G.user_id > 0) {
                $(this).parent().parent().find(".mpc__twshare").removeClass('hidden');
                $(".mpc__twbody").stop().animate({scrollTop: $(".mpc__twbody .mpc__twlinks").offset().top - 150}, '200', 'swing');
            } else {
                $(".header__login").trigger('click');
                // U.copyToClipboard(document.location.href);
                // let btn = $(this);
                // btn.data('text', 'Посилання скопійовано');
                //
                // TOOLTIP.open(btn, {
                //     subclass: 'tooltip-black tooltip-black-auto',
                //     target: 'black',
                //     place: 'top',
                //     fadeinout: true
                // });
            }
        });

        jQuery("body").on('click', '.js-mpc__saveform', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let form = $(this).parent();

            if ($.trim(form.find('input').val())!='') {
                MAKEPC.save($.trim(form.find('input').val())).then(() => {
                    if (!U.isMobile()) {
                        U.close_all();
                    } else {
                        $(".mpc__twshare").addClass('hidden');
                    }

                    let btn = U.isMobile() ? $('.js-mpc__savemobile') : $('.js-mpc__save');
                    btn.data('text', 'Конфігурацію збережено');
                    TOOLTIP.open(btn, {
                        subclass: 'tooltip-black tooltip-black-auto',
                        target: 'black',
                        place: 'top',
                        fadeinout: true
                    });
                });
            } else {
                form.find('label span').removeClass('hidden');
            }
        });

        jQuery("body").on('click', '.js-mpc__share', function (e, addr = '.js-mpc__share') {
            e.preventDefault();
            e.stopPropagation();

            U.copyToClipboard(document.location.href);
            let btn = addr=='.js-mpc__share' ? $(this) : $(addr);
            btn.data('text', 'Посилання скопійовано');
            TOOLTIP.open(btn, {
                subclass: 'tooltip-black tooltip-black-auto',
                target: 'black',
                place: 'top',
                fadeinout: true
            });
        });

        jQuery("body").on('click', '.js-pcs__itemremove', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            TOOLTIP.confirm(btn, 'Підтверджуєте видалення ?', [
                {
                    title: 'Ні',
                    class: 'cancel',
                    onclick: () => {
                        TOOLTIP.hide();
                    }
                },
                {
                    title: 'Так',
                    class: 'success',
                    onclick: () => {
                        MAKEPC.remove(btn.parents('.pcs__item').data('id')).then(() => {
                            btn.parents('.pcs__item').remove();
                            TOOLTIP.hide();
                        });
                    }
                },
            ]);
        });

        jQuery("body").on('change', '.js-mpc__approverights', function (e) {
            let input = $(this);

            if (input.prop('checked')) {
                $(".js-mpc__totalbtn").removeClass('disabled');
            } else {
                $(".js-mpc__totalbtn").addClass('disabled');
            }
        });

        jQuery("body").on('click', '.js-mpc__totalbtnmobile', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(".js-mpc__totalapprove").toggleClass('mpc__totalapprove-show');
        });

        jQuery("body").on('click', '.js-mpc__totalbtn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            if (!U.isMobile() && btn.hasClass('disabled')) {
                return;
            }

            $(".js-mpc__totalapprove").removeClass('mpc__totalapprove-show');

            let skus = MAKEPC.skus;

            if (skus.length > 0) {
                let service_code = MAKEPC.service_code();

                if (service_code > 0) {
                    TOOLTIP.confirm(btn, 'Додати послугу збірки та налаштування ПК ?', [
                        {
                            title: 'Ні',
                            class: 'cancel',
                            onclick: () => {
                                CARD.addmany(MAKEPC.products).then(() => {
                                    MAKEPC.write2lead();
                                });

                                TOOLTIP.hide();
                            }
                        },
                        {
                            title: 'Так',
                            class: 'success',
                            onclick: () => {
                                CARD.addmany(MAKEPC.products).then(() => {
                                    MAKEPC.write2lead();
                                });
                                TOOLTIP.hide();
                            }
                        },
                    ]);
                } else {
                    CARD.addmany(MAKEPC.products).then(() => {
                        MAKEPC.write2lead();
                    });
                }
            } else {
                btn.data('text', 'Спочатку заповніть конфігурацію');
                TOOLTIP.open(btn, {
                    subclass: 'tooltip-black tooltip-black-auto',
                    target: 'black',
                    place: 'top',
                    fadeinout: true
                });
            }
        });

        jQuery("body").on('click', '.js-mpc__addsettocart', function (e) {
            e.preventDefault();
            e.stopPropagation();
            CARD.addmany($(this).data('skus'));
        });

        jQuery("body").on('click', '.js-mpc__addservice', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".js-mpc__servicegoods").toggleClass('hidden')
        });

        if (G.command=='init_makepc') {
            MAKEPC.set_id($(".js-makepc__set_id").val());
            MAKEPC.init($(".js-makepc__skus").val(), parseInt($(".js-makepc__set_id").val()) > 0 ? true : false);

            setTimeout(function () {
                $(window).on('popstate', function (e) {
                    let spl = MAKEPC.was_page.split('/');
                    let spl2 = document.location.pathname.split('/');
                    let was = document.location.href.substr(document.location.origin.length);

                    if (spl[1] == spl2[1] && MAKEPC.was_page != was) {
                        let skus = document.location.pathname.split('makepc/');
                        skus = skus[1] ?? '';
                        skus = skus.split('/');
                        MAKEPC.init(skus[0], true);
                    } else {
                        return true;
                    }
                });
            }, 0);
        }

    });
}

init_MAKEPC_events()